import { supabase } from '../supabase.js';

/**
 * Modal: change (or set) the signed-in user's password.
 * Works for email/password users (rotates) and OAuth users (sets a backup).
 */
export function openChangePasswordModal() {
  const overlay = document.createElement('div');
  overlay.className = 'sig-modal-overlay';
  overlay.innerHTML = `
    <div class="sig-modal sig-modal-narrow" role="dialog" aria-modal="true">
      <div class="sig-modal-head">
        <div class="sig-modal-title">Change password</div>
      </div>
      <div class="sig-modal-body cp-body">
        <label class="cp-label">New password
          <input type="password" id="cp-new" minlength="8" required autocomplete="new-password" />
        </label>
        <label class="cp-label">Confirm new password
          <input type="password" id="cp-confirm" minlength="8" required autocomplete="new-password" />
        </label>
        <div class="cp-msg" id="cp-msg"></div>
      </div>
      <div class="sig-modal-actions">
        <button class="btn btn-ghost"   data-action="cancel">Cancel</button>
        <button class="btn btn-primary" data-action="save" id="cp-save">Save</button>
      </div>
    </div>
  `;
  document.body.appendChild(overlay);

  const newEl     = overlay.querySelector('#cp-new');
  const confirmEl = overlay.querySelector('#cp-confirm');
  const msg       = overlay.querySelector('#cp-msg');
  const saveBtn   = overlay.querySelector('#cp-save');
  newEl.focus();

  function close() { overlay.remove(); document.removeEventListener('keydown', onKey); }
  function onKey(e) { if (e.key === 'Escape') close(); }
  document.addEventListener('keydown', onKey);

  overlay.addEventListener('click', async (e) => {
    const action = e.target.dataset?.action;
    if (action === 'cancel') return close();
    if (action !== 'save')   return;

    msg.textContent = '';
    msg.className = 'cp-msg';

    const np = newEl.value;
    const cp = confirmEl.value;

    if (np.length < 8) {
      msg.textContent = 'Password must be at least 8 characters.';
      msg.classList.add('error'); return;
    }
    if (np !== cp) {
      msg.textContent = 'Passwords do not match.';
      msg.classList.add('error'); return;
    }

    saveBtn.disabled = true; saveBtn.textContent = 'Saving…';
    const { error } = await supabase.auth.updateUser({ password: np });
    saveBtn.disabled = false; saveBtn.textContent = 'Save';

    if (error) {
      msg.textContent = error.message;        // surfaces HaveIBeenPwned hits etc.
      msg.classList.add('error');
      return;
    }

    msg.textContent = 'Password updated.';
    msg.classList.add('success');
    setTimeout(close, 900);
  });
}
